import { render, staticRenderFns } from "./RegistroEvaluaciones.vue?vue&type=template&id=49623d3e&scoped=true&"
import script from "./RegistroEvaluaciones.vue?vue&type=script&lang=js&"
export * from "./RegistroEvaluaciones.vue?vue&type=script&lang=js&"
import style0 from "./RegistroEvaluaciones.vue?vue&type=style&index=0&id=49623d3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49623d3e",
  null
  
)

export default component.exports